import { render, staticRenderFns } from "./BookTypeOption.vue?vue&type=template&id=1c4f1e8c"
import script from "./BookTypeOption.vue?vue&type=script&lang=ts"
export * from "./BookTypeOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports